import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

import { PurchaseProofForm } from '@client/components/invoices/purchase-proof-form.tsx';
import { PurchaseProofSteps } from '@client/components/invoices/purchase-proof-steps.tsx';
import { PageContainer } from '@client/components/layout/page-container.tsx';
import { Link } from '@tanstack/react-router';
import { Button } from '@ui/button.tsx';
import { Card, CardContent } from '@ui/card.tsx';

/** Displays the purchase-proof deposit page and its workflow guidance. */
export function Invoices() {
  const { t } = useTranslation();

  return (
    <PageContainer className="py-10 lg:py-16">
      <section>
        <div className="mb-8">
          <h1 className="font-bold text-3xl text-foreground md:text-4xl lg:text-[2.75rem] lg:leading-[3.5rem]">
            {t('invoices.title')}
          </h1>
          <p className="mt-2 max-w-4xl text-sm text-muted-foreground">
            {t('invoices.description')}
          </p>
        </div>

        <Card className="mx-auto max-w-2xl rounded-3xl border-0">
          <CardContent className="p-6 sm:p-8">
            <PurchaseProofForm />
          </CardContent>
        </Card>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <span className="font-medium">{t('invoices.history.link.question')}</span>
          <Button asChild rounded="full" variant="outline">
            <Link to="/user/invoices">
              {t('invoices.history.link')}
              <ArrowRight aria-hidden />
            </Link>
          </Button>
        </div>
      </section>

      <PurchaseProofSteps />
    </PageContainer>
  );
}
